<template>
  <div class="head-wrapper ">
    <div class="clearfix">
      <img
        class="logo"
        src="../assets/logo.png"
        alt=""
      >
      <div class="tab-wrapper">
        <span
          v-for="(item,idx) in arrTabs"
          :key="idx"
          :class="[idx==tabIndex?'tab-on':'']"
          @click="tabClick(idx)"
        >{{item}}</span>
      </div>
    </div>
    <img
      class="bd-img"
      src="../assets/head_bd.png"
      alt=""
    >
  </div>
</template>

<script>
export default {
  name: 'tophead',
  props: {
    index: Number
  },
  data () {
    return {
      arrTabs: [
        '首页',
        'APP简介',
        '公司简介',
        '联系我们'
      ],
      tabIndex: 0
    };
  },
  methods: {
    tabClick (index) {
      this.tabIndex = index
      this.$emit('tabclick', index)
    }
  },
  watch: {
    index (newValue, old) {
      console.log(old)
      this.tabIndex = newValue
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.head-wrapper {
  width: 100%;
}

.head-wrapper .bd-img {
  margin: 0 auto;
  display: block;
  width: 100%;
}

.head-wrapper .head-wrapper.logo {
  margin-top: 7px;
  width: 403px;
  height: 50px;
  float: left;
}

.head-wrapper .tab-wrapper {
  float: right;
  font-size: 18px;
  margin-right: 100px;
  height: 64px;
}

.head-wrapper .tab-wrapper span {
  margin-right: 40px;
  line-height: 64px;
  color: #848383;
  font-weight: bold;
  cursor: pointer;
}

.head-wrapper .tab-on {
  border-bottom: solid 4px #dc371b;
}
</style>
